/* ========================================================================
 * FD:          string
 * Child:       --
 * Version:     1.0
 * ========================================================================
 * ======================================================================== 
 * 2/22/2016: creation
*/


/* ========================================================================
 *  vars
 * ========================================================================
*/



/* ========================================================================
 *  functions
 * ========================================================================
*/
////  function 
//String.FN = function (x) {
   
//};





/* ========================================================================
 *  display
 * ========================================================================
*/

//  get bool
String.prototype.getBool = function () {
    return (/^true$/i).test(this);
}


//  capital 1st letter
String.prototype.capitalizeFirstLetter = function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
}


